import React, { Component, Fragment } from 'react';

import {
  Button,
  Form,
  Radio,
  Select,
  Row,
  Col,
  Switch,
  Tooltip,
  Icon,
} from 'antd';

import _ from 'lodash';
import { connectForm } from '../../form';
import { ErrorsList } from '../../ErrorsList';
import { ButtonBar } from '../../elements';

export const formatPrice = cents => `$${Math.floor(cents / 100)}`;

const EXPIRY_MANAGEMENT_INFO = 'Expiry Management allows you to define your own types and receive expiring and expired notifications for those accreditations.';

@connectForm(() => ({}))
class SubscriptionForm extends Component {
  state = {
    expiryManagementAddOn: false,
    deprecatedPlanWarning: false,
    planSize: 50,
  }

  componentDidMount() {
    const {
      form, current, plans,
    } = this.props;

    const billingPeriod = form.getFieldValue('billingPeriod') || (current && current.billingPeriod) || 'yearly';
    const matchingTier = current && plans && _.minBy(_.filter(plans[billingPeriod].tiers, item => item.size >= current.planSize), 'size');
    const warnNewPlan = current.billingPeriod && matchingTier && matchingTier.price !== current.price;

    this.setState({ deprecatedPlanWarning: warnNewPlan });
    this.setState({ expiryManagementAddOn: this.props.current.expiryManagementAddon });
    this.setState({ planSize: this.props.current.planSize });
  }

  onAddonChange = checked => {
    this.setState({ expiryManagementAddOn: checked });
  };

  warning = getConnectedFieldDecorator => (
    <Form.Item label="Subscription Level Warning">
      { getConnectedFieldDecorator('expiryManagementAddOn', {
        initialValue: this.state.expiryManagementAddOn,
      })(
        <>
          <p style={{ marginBottom: '0' }}>
            <span style={{ color: 'red' }}>You are on an older subscription level than our current pricing.</span> If you proceed, your verifiable subscription plan will change to be as per our <a href="https://weareoho.com/pricing/" target="_blank" rel="noopener noreferrer">latest pricing</a>.
            Please confirm you want to proceed, or contact support@weareoho.com to add expiry management on your existing plan.
          </p>
        </>,
      )}
    </Form.Item>
  );

  handleOnSelect = newPlanSize => {
    this.setState({ planSize: newPlanSize });
  }

  render() {
    const {
      form, current, plans, expiryManagementPlans, saveInProgress, editMode = true, cancelable = true,
    } = this.props;
    const { getConnectedFieldDecorator } = form;
    const billingPeriod = form.getFieldValue('billingPeriod') || (current && current.billingPeriod) || 'yearly';
    const { tiers } = plans[billingPeriod];
    const { tiers: expiryManagementTiers } = expiryManagementPlans[billingPeriod];
    const matchedAddonTier = expiryManagementTiers.find(tier => tier.size === this.state.planSize);
    const expiryManagementAddOnText = this.state.expiryManagementAddOn
      && matchedAddonTier
      && <span>{`+ ${formatPrice(matchedAddonTier.price)}/${{ monthly: 'Month', yearly: 'Year' }[billingPeriod]}`}</span>;

    const Wrapper = editMode ? Form : Fragment;

    return (
      <Wrapper {...(editMode && { onSubmit: this.props.handleSubmit })}>
        <ErrorsList errors={this.props.globalErrors}/>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col sm={24} md={8}>
            <Form.Item label="Billing Period">
              { getConnectedFieldDecorator('plan.billingPeriod', {
                initialValue: billingPeriod,
              })(
                <Radio.Group>
                  <Radio.Button value="yearly">Yearly</Radio.Button>
                  <Radio.Button value="monthly">Monthly</Radio.Button>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
          <Col sm={24} md={8}>
            <Form.Item label="Plan">
              { getConnectedFieldDecorator('plan.planSize', {
                initialValue: current ? this.state.planSize : tiers[0].size,
                rules: [{
                  required: true,
                  message: 'Please select a plan size',
                }],
              })(
                <Select placeholder='Select your Oho plan' onSelect={this.handleOnSelect}>
                  {tiers.map(({ size, price }) => (<Select.Option key={size} value={size}>
                Up to {size} people for {formatPrice(price)} per {{ monthly: 'Month', yearly: 'Year' }[billingPeriod]}
                  </Select.Option>))}
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col sm={24} md={8}>
            <Form.Item label={
              <>
                <span>Expiry Management{' '}</span>
                <span>
                  <Tooltip title={EXPIRY_MANAGEMENT_INFO}>
                    <Icon type="info-circle"/>
                  </Tooltip>
                </span>

              </>
            }
            >
              { getConnectedFieldDecorator('plan.expiryManagementAddOn', {
                initialValue: current ? this.state.expiryManagementAddOn : false,
                valuePropName: 'checked',
              })(
                <Switch onChange={this.onAddonChange} />,
              )} {expiryManagementAddOnText}
            </Form.Item>
          </Col>
        </Row>


        {this.state.deprecatedPlanWarning ? this.warning(getConnectedFieldDecorator) : null}
        { editMode && <ButtonBar>
          {cancelable && (
            <Button
              disabled={saveInProgress}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          )}
          <Button
            loading={saveInProgress}
            htmlType='submit'
            type='primary'
          >
            {this.props.submitText || (this.state.deprecatedPlanWarning ? 'Update Subscription' : 'Save')}
          </Button>
        </ButtonBar> }
      </Wrapper>
    );
  }
}

export {
  SubscriptionForm,
};
